import { Breadcrumbs } from '@components';
import { ManualBonusForm } from '@modules/bonuses';
import '@shared/styles/page.css';
import './BonusesPage.css';

export default function BonusesPage() {
  return (
    <div className="page-container bonuses-page">
      <Breadcrumbs
        items={[
          { label: 'Главная', path: '/' },
          { label: 'Бонусная система' },
        ]}
      />

      <div className="bonuses-page-head">
        <h1 className="bonuses-page-title">Бонусная система</h1>
        <p className="bonuses-page-subtitle">
          Ручное начисление и списание бонусов покупателям из пула выбранного магазина —
          например за офлайн-заказ или компенсацию.
        </p>
      </div>

      <div className="bonuses-page__scroll">
        <div className="content-wrapper bonuses-page__content-wrapper">
          <div className="bonuses-page__content">
            <ManualBonusForm />
          </div>
        </div>
      </div>
    </div>
  );
}
